import { useEffect, useState } from 'react';

import {
  ListItemAvatar,
  ListItem,
  ListItemText,
  Typography,
  useTheme,
} from '@mui/material';

import { AddCircle } from '@mui/icons-material';

import { getStyled } from './styles';

const ContactListItemAdd = ({
  contactModalOpen,
  setContactModalOpen,
  contactName,
  onClick,
}) => {
  const theme = useTheme();
  const classes = getStyled(theme);

  const [name, setName] = useState(contactName);

  useEffect(() => {
    const fetchName = () => {
      setName(contactName);
    };
    fetchName();
  }, [contactName]);

  return (
    <ListItem
      style={classes.contact}
      key={contactModalOpen}
      onClick={() => {
        setContactModalOpen(true);
        if (onClick) onClick();
      }}
    >
      <ListItemAvatar style={{ marginLeft: '-8px' }}>
        <AddCircle
          style={{
            width: '50px',
            height: '50px',
          }}
        />
      </ListItemAvatar>
      <ListItemText
        disableTypography
        primary={
          <span style={classes.contactNameWrapper}>
            <Typography
              noWrap
              component='span'
              variant='body2'
              style={classes.infoLabelLabel}
            >
              Adicionar <b style={classes.contactNameLabel}>{name}</b>?
            </Typography>
          </span>
        }
      />
    </ListItem>
  );
};

export default ContactListItemAdd;
